import React from 'react';
import Container from 'mf-react-ui/Container';
import Link from 'mf-react-ui/Link';
import { H1, H3, P } from 'mf-react-ui/Typography';
import Button from 'mf-react-ui/Button';
import { Link as LinkRouter } from 'react-router-dom';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Orders } from '../../types';
import { AppRoute } from '../../const';
import './OrdersPage.scss';

type Props = {
  orders: Orders;
  fetchOrdersByApi: () => void;
};

const OrdersPage: React.FC<Props> = (props) => {
  const { orders, fetchOrdersByApi } = props;

  return (
    <>
      {!isEmpty(orders) ? (
        <section className="section section_background-dark section-orders">
          <Container>
            <>
              <H1 view="h2" className="section-orders__title">
                Вы подарили
              </H1>
              <P className="section-orders__description">
                Как только пользователь активирует подарок на{' '}
                <Link as={LinkRouter} to={AppRoute.PROMOCODE}>
                  podarok.megafon.ru
                </Link>
                {' '}
                его статус поменяется на «Активирован»
              </P>
              <div className="tile-grid-wrapper tile-grid-wrapper_for_orders">
                <ul className="tile-grid">
                  {
                    // @ts-ignore
                    orders.map((order) => {
                      const { id, name, promocode, activated } = order;
                      return (
                        <li key={id} className="tile-grid__cell">
                          <div className={cn('order-tile', activated && 'order-tile_activated')}>
                            <ul className="order-tile__list">
                              <li className="order-tile__item">
                                <H3 className="order-tile__title">Подарок</H3>
                                <P className="order-tile__name">{name}</P>
                              </li>
                              <li className="order-tile__item">
                                <H3 className="order-tile__title">Промокод</H3>
                                <P className="order-tile__promo-code">
                                  <span className="order-tile__promo-code-text">{promocode}</span>
                                  {!activated && (
                                    <CopyToClipboard text={promocode}>
                                      <Button
                                        className="order-tile__promo-code-button"
                                        view="clear"
                                        icon={
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="22"
                                          >
                                            <path
                                              d="M14 4v18H0V4h14zm-2 2H2v14h10V6zm6-6v20h-2V2H4V0h14z"
                                              fillRule="nonzero"
                                            />
                                          </svg>
                                        }
                                      />
                                    </CopyToClipboard>
                                  )}
                                </P>
                              </li>
                              <li className="order-tile__item">
                                <H3 className="order-tile__title">Статус</H3>
                                <P className="order-tile__status">
                                  {activated ? 'Активирован' : 'Не активирован'}
                                </P>
                              </li>
                            </ul>
                          </div>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </>
          </Container>
        </section>
      ) : (
        <div className="orders-waiting section">
          <div className="orders-waiting__inner">
            <div className="orders-waiting__img" />
            <H1 view="p" className="orders-waiting__message">
              Если вы купили подарок,
              <br />
              скоро он здесь появится :)
            </H1>
            <div className="orders-waiting__actions">
              <Button
                className="orders-waiting__button"
                view="light"
                onClick={() => fetchOrdersByApi()}
              >
                Обновить страницу
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrdersPage;
